import { FieldPath, UseFormSetValue } from "react-hook-form";

const getAddressByZipCode = async <T extends Record<string, any>>(
  rawCep: string,
  basePath: FieldPath<T>,
  setValue: UseFormSetValue<T>,
  showFeedback: (msg: string, type: "error" | "success") => void
) => {
  try {
    const response = await fetch(`https://viacep.com.br/ws/${rawCep}/json/`);
    const data = await response.json();

    if (data.erro) {
      showFeedback("CEP não encontrado", "error");
      return;
    }

    setValue(`${basePath}.rua` as FieldPath<T>, data.logradouro || "", {
      shouldValidate: true,
      shouldDirty: true,
    });
    setValue(`${basePath}.bairro` as FieldPath<T>, data.bairro || "", {
      shouldValidate: true,
      shouldDirty: true,
    });
    setValue(`${basePath}.cidade` as FieldPath<T>, data.localidade || "", {
      shouldValidate: true,
      shouldDirty: true,
    });
    setValue(`${basePath}.uf` as FieldPath<T>, data.uf || "", {
      shouldValidate: true,
      shouldDirty: true,
    });
  } catch {
    showFeedback("Erro ao buscar o CEP", "error");
  }
};

const enderecoService = { getAddressByZipCode };

export default enderecoService;
